export default __webpack_public_path__ + "76ab350e9ca9f9525151d7ed96b3898a.png";